// extracted by mini-css-extract-plugin
export default {"CardContainer":"CardFeature_CardContainer__kWdRR","CardTitle":"CardFeature_CardTitle__L8+KO","CardText":"CardFeature_CardText__pztgP"};